export default `
	name
    html
    date_range
`;
